/**
 * Billing accounts page — routed staff list of billing accounts.
 *
 * Chrome only: the billing trail plus the server-backed accounts grid,
 * which owns its own filters, search, and row navigation.
 *
 * Contains:
 * - BillingAccountsView — routed page (default export)
 */
import { Box } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { BillingAccountsGrid, BillingTitleBar } from '@sophocles/views/billing/components';

function BillingAccountsView() {
  const { t } = useTranslation();

  return (
    <>
      <BillingTitleBar title={t('billing.accountManagement', 'Account Management')} />
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          flex: 1,
          minHeight: 0,
          px: 'var(--page-px)',
          pb: 'var(--page-py)',
        }}
      >
        <BillingAccountsGrid />
      </Box>
    </>
  );
}

export default BillingAccountsView;
